<app-banner [heading]="'OUR KINDERGARTEN'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
   
    
    <!-- ======= About Section ======= -->
    <section id="about" class="about">

      <div class="container">
        <div class="row">

          <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/kindergarten/kindergarten-1.jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-lg-6 col-md-6">
            <div class="about-content">
              <h6 class="">Kindergarten @ TGS</h6>
              
              <p>The most happening place is Kindergarten Section of Tagore Global School, Kurukshetra.
			  This section is dedicated to our tiny tots , they enjoy their early years of childhood with a lot 
			  of enthusiasm , innocence &amp; joy.<br><br>The colorful classrooms &amp; learning environment is equipped with
			  Audio Visual Aids &amp; Smart Classrooms at TGS  - Kurukshetra.The outdoor swings &amp;
			  slides are the key attractions at TGS - Kurukshetra.<br><br>The installation of Indoor &amp; Outdoor toys &amp; 
			  furniture at Tagore Global School  is having round edges &amp; are user friendly. The entire
			  area is hygienic &amp; safe for our tiny tots.
			  
			  </p>
              
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/kindergarten/kindergarten-2.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/kindergarten/kindergarten-3.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/kindergarten/kindergarten-4.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/kindergarten/kindergarten-5.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/kindergarten/kindergarten-6.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/kindergarten/kindergarten-7.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 
		  
		</div>
      </div>
	</section><!-- End About Section -->
	
	
	
    
    
  </main>